export const ELEMENT_EMOJI_TYPE = 'emoji';

export const EmojiElement = {
  type: ELEMENT_EMOJI_TYPE,
};
